export const JOB_STATUSES = {
  NOT_STARTED: "Not Started",
  IN_PROGRESS: "In Progress",
  COMPLETE: "Completed",
};

export const JOB_STATUS_IDS = {
  NOT_STARTED: 1,
  IN_PROGRESS: 2,
  COMPLETE: 3,
};

export const JOB_STATUS_OPTIONS = [
  {
    id: JOB_STATUS_IDS.NOT_STARTED,
    label: JOB_STATUSES.NOT_STARTED,
  },
  {
    id: JOB_STATUS_IDS.IN_PROGRESS,
    label: JOB_STATUSES.IN_PROGRESS,
  },
  {
    id: JOB_STATUS_IDS.COMPLETE,
    label: JOB_STATUSES.COMPLETE,
  },
];

export const WORK_STATUS = [
  "Verified",
  "Unverified",
  "Blocked",
  "Cancelled",
]?.map((label, i) => ({
  id: i + 1,
  label,
}));
